// extracted by mini-css-extract-plugin
export default {"disclosuresContainer":"disclosures-container__disclosures-container__LKdSe","acknowledgementDiv":"disclosures-container__acknowledgement-div__Miejg"};